import { useEffect, useState } from 'react';
import { useFrame } from '@react-three/fiber';
import { IdProps } from '~/components/ChatAvatar/Canvas/Character/RobotCharacter';
import { expression } from '~/components/ChatAvatar/Canvas/Character/animationData/expression';
import { AnimationDuration } from '~/constants/Canvas';
import useChatAvatarStore from '~/store/useChatAvatarStore';

const useAvatarQueue = ({ id }: IdProps) => {
  const avatarQueue = useChatAvatarStore(
    (state) => state.character?.[id]?.avatarQueue,
  );
  const shiftAvatarQueue = useChatAvatarStore(
    (state) => state.shiftAvatarQueue,
  );

  const { setAvatarQueue, deleteQueue, setExpressionType } = useChatAvatarStore(
    (state) => ({
      setAvatarQueue: state.setAvatarQueue,
      deleteQueue: state.deleteQueue,
      setExpressionType: state.setExpressionType,
    }),
  );

  const [nowTime, setNowTime] = useState(0);

  useEffect(() => {
    if (avatarQueue?.name) {
      setExpressionType({
        id,
        type: avatarQueue.name,
      });
    }
  }, [avatarQueue?.name, id]);

  useFrame((state) => {
    if (avatarQueue) {
      /**
       * 현재 진행중인 Queue가 있는 경우
       */
      const diff = state.clock.getElapsedTime() - nowTime;

      if (diff > avatarQueue.duration) {
        setNowTime(state.clock.getElapsedTime());
        deleteQueue({ id });
      }
      return;
    }
    if (!avatarQueue && shiftAvatarQueue({ id })) {
      /**
       * 진행중인 queue는 없고 남은 queue가 있는 경우
       */
      return;
    }

    if (!avatarQueue && !shiftAvatarQueue({ id })) {
      /**
       * 진행중인 queue가 없고, 남은 queue도 없는 경우
       * idle 모션과 표정을 Queue에 추가함
       */
      setNowTime(state.clock.getElapsedTime());
      setAvatarQueue({
        id,
        queue: {
          type: 'Neutral',
          name: 'neutral01',
          duration: AnimationDuration.idle,
          value: expression['neutral'].morphTargets,
        },
      });
    }
  });
};

export default useAvatarQueue;

/* 
    예시 큐
    {
        "type": "Happy",  # 기본 키
    "name": "grin02",  # 정렬 키
    "duration": 1,
    "value": {
        "browInnerUp": [0.3],
        "eyeSquintLeft": [1],
        "eyeSquintRight": [1],
        "jawOpen": [0.3],
        "mouthDimpleLeft": [0.2],
        "mouthDimpleRight": [0.2],
        "mouthPressLeft": [0.5],
        "mouthPressRight": [0.5],
        "mouthShrugUpper": [0.4],
        "mouthSmile": [0.7],
        "mouthUpperUpLeft": [0.3],
        "mouthUpperUpRight": [0.3],
        "noseSneerLeft": [0.4],
        "noseSneerRight": [0.4],
    },
    }
*/
